import { render, staticRenderFns } from "./recommedmenu.vue?vue&type=template&id=1372ec7e&scoped=true"
import script from "./recommedmenu.vue?vue&type=script&lang=js"
export * from "./recommedmenu.vue?vue&type=script&lang=js"
import style0 from "./recommedmenu.vue?vue&type=style&index=0&id=1372ec7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372ec7e",
  null
  
)

export default component.exports